import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const SupportIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={getDefaultHeight(svgProps, 24)}
      {...svgProps}
    >
      <path
        d="M4.5 18h-.75a3 3 0 01-3-3v-3a3 3 0 013-3h.75a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75z"
        fill="none"
        stroke={color ?? "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20.25 18h-.75a.75.75 0 01-.75-.75v-7.5A.75.75 0 0119.5 9h.75a3 3 0 013 3v3a3 3 0 01-3 3z"
        fill="none"
        stroke={color ?? "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3.75 9A8.25 8.25 0 0112 .75h0A8.25 8.25 0 0120.25 9"
        fill="none"
        stroke={color ?? "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M15 21.75h2.25a3 3 0 003-3h0V18"
        fill="none"
        stroke={color ?? "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13.5 23.25H12a1.5 1.5 0 01-1.5-1.5h0a1.5 1.5 0 011.5-1.5h1.5a1.5 1.5 0 011.5 1.5h0a1.5 1.5 0 01-1.5 1.5z"
        fill="none"
        stroke={color ?? "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </SVG>
  );
};
